import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-[calc(100vh-76px-32px)] md:h-[calc(100vh-96px-48px)] flex flex-col justify-center" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_3 = { class: "aspect-w-1 aspect-h-1" }
const _hoisted_4 = { class: "aspect-w-1 aspect-h-1" }
const _hoisted_5 = { class: "col-span-2 mt-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://houdijk100.com",
  class: "absolute bottom-4 left-0 w-full font-bold text-tertiary text-center underline"
}, " houdijk100.com ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_no_navigation_layout = _resolveComponent("no-navigation-layout")!

  return (_openBlock(), _createBlock(_component_no_navigation_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "bg-tertiary rounded text-dark flex items-center justify-center gap-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trigger('previous')))
            }, [
              _createVNode(_component_ui_icon, {
                name: "arrow-left",
                class: "text-xs"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t('previous')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "bg-tertiary rounded text-dark flex items-center justify-center gap-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trigger('next')))
            }, [
              _createTextVNode(_toDisplayString(_ctx.t('next')) + " ", 1),
              _createVNode(_component_ui_icon, {
                name: "arrow-right",
                class: "text-xs"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "p-4 bg-secondary rounded text-white flex items-center justify-center w-full",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trigger('refresh')))
            }, _toDisplayString(_ctx.t('back_to_start')), 1)
          ])
        ]),
        _hoisted_6
      ])
    ]),
    _: 1
  }))
}